import { t } from "@redotech/redo-i18n";
import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { waitFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isWaitStepValid,
  WaitState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import WaitIcon from "@redotech/redo-web/icon-old/wait.svg";
import { produce } from "immer";
import * as React from "react";
import { StepDownstream, StepType, StepTypeDetailsProps } from "../step";

export const WAIT = (
  Details: React.ComponentType<StepTypeDetailsProps<WaitState>>,
): StepType<WaitState, ModelStep.Wait> => ({
  Details: (props: StepTypeDetailsProps<WaitState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: STEP_TYPE_NAMES[ModelStep.WAIT],
  valid(state) {
    return isWaitStepValid(state).valid;
  },
  Icon: WaitIcon,
  iconColor: "success",
  description(state) {
    return t("{{count}} days", { count: +state.numDays });
  },
  empty: { numDays: 0, next: undefined },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(`Invalid handle index ${handleIndex} for Wait step`);
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  layout() {
    return BlockLayout.FULL;
  },
  toModel(state, id) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.WAIT,
      numDays: state.numDays,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      next: id(state.next!),
    };
  },
  fromModel(model, id) {
    return waitFromModel(model, id);
  },
});
